import React from "react";
import {observer} from "mobx-react-lite";
import {useStores} from "../../stores";
import {useLocation, useNavigate} from "react-router";
import {useAuth0} from "@auth0/auth0-react";
import {Button} from "@mui/material";
import {auth0Login} from "./Auth0Login";
import {environment} from "../../env";
import {useRollbar} from "@rollbar/react";

export const Auth0LoginButton: React.FC = observer(() => {
    const {authStore} = useStores();
    const navigate = useNavigate();
    const location = useLocation();
    const auth0Context = useAuth0();
    const rollbar = environment.rollbarConfig ? useRollbar() : undefined;

    if (authStore.authentication.isLoggingIn === false) {
        return <Button
            variant={environment.hasMultipleAuthProviders ? 'outlined' : 'contained'}
            onClick={() => auth0Login(authStore, auth0Context, location, navigate, rollbar)}>
            Log in
            {environment.hasMultipleAuthProviders && <><br/>(2024 version)</>}
        </Button>
    } else {
        // keep silent
        return <></>
    }
});
